"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_1 = require("react-science/ui");
function ToggleButton(props) {
    const { children, value = null, isActive = false, onChange = () => null, isVisible = true, id, title, } = props;
    const [active, setActive] = (0, react_1.useState)(props.isActive);
    const toggleButton = (0, react_1.useCallback)(() => {
        const _isActive = !active;
        setActive(_isActive);
        if (_isActive) {
            onChange(value);
        }
        else {
            onChange(null);
        }
    }, [active, onChange, value]);
    (0, react_1.useEffect)(() => {
        setActive(isActive);
    }, [isActive]);
    if (!isVisible) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(ui_1.Toolbar.Item, { onClick: toggleButton, title: title, id: id, active: active, children: children }));
}
exports.default = ToggleButton;
